import React from "react";
import "../../styles/Home-page-component/capabilities.css";

const CapabilitiesSection = () => {
  return (
    <section className="capabilities-section">
      <div className="container">

        <h2 className="section-title">
          Our Capabilities
        </h2>

        <div className="capabilities-grid">

          {/* 1 */}
          <div className="capability-card">
            <h3>AI-Powered B2B SaaS</h3>
            <p>
              AI-augmented tools and micro-SaaS solutions for business automation and intelligence
            </p>

            <ul>
              <li>Developer productivity tools (test generation, code review)</li>
              <li>AI chatbots & help desk systems</li>
              <li>AI Skills benchmarking platforms</li>
            </ul>
          </div>

          {/* 2 */}
          <div className="capability-card">
            <h3>Cloud-Native Engineering</h3>
            <p>
              Platform engineering with AI-optimized infrastructure on AWS, GCP, and Azure
            </p>

            <ul>
              <li>Cloud migrations & cost optimization</li>
              <li>Kubernetes, CI/CD & observability</li>
              <li>Architecting AI workloads (vector DBs, MLOps)</li>
            </ul>
          </div>

          {/* 3 */}
          <div className="capability-card">
            <h3>Engineering Services Outsourcing</h3>
            <p>
              Specialized engineering for niche industries with fixed costs and flexible staffing
            </p>

            <ul>
              <li>Industrial & manufacturing software (IIoT dashboards)</li>
              <li>Energy & sustainability monitoring</li>
              <li>AI-driven multimedia & telecom solutions</li>
            </ul>
          </div>

          {/* 4 */}
          <div className="capability-card">
            <h3>E2E AI Evaluation & Talent Platforms</h3>
            <p>
              Comprehensive AI-driven evaluation systems and talent management solutions
            </p>

            <ul>
              <li>AI Skills assessment & benchmarking</li>
              <li>Talent evaluation & matching</li>
              <li>Workforce readiness tracking</li>
            </ul>
          </div>

          {/* 5 */}
          <div className="capability-card">
            <h3>Cybersecurity & Compliance</h3>
            <p>
              Enterprise-grade security and compliance solutions powered by AI
            </p>

            <ul>
              <li>AI-driven threat detection</li>
              <li>Compliance automation (SOC2, GDPR, HIPAA)</li>
              <li>Security monitoring & incident response</li>
            </ul>
          </div>

          {/* 6 */}
          <div className="capability-card">
            <h3>Enterprise AI (Self-Hosted)</h3>
            <p>
              Private AI systems for enterprises that cannot send data to external cloud providers
            </p>

            <ul>
              <li>LLM deployment & optimization (Llama, Mistral)</li>
              <li>Retrieval-Augmented Generation (RAG) systems</li>
              <li>AI copilots for enterprise workflows</li>
            </ul>
          </div>

          {/* 7 */}
          <div className="capability-card">
            <h3>AI for DevOps (AIOps)</h3>
            <p>
              Intelligent operations that predict incidents, reduce downtime, and optimize infrastructure
            </p>

            <ul>
              <li>Incident prediction & AI root-cause analysis</li>
              <li>Log anomaly detection & intelligent monitoring</li>
              <li>Cost optimization engines for AWS/Azure</li>
            </ul>
          </div>

          {/* 8 */}
          <div className="capability-card">
            <h3>Industry-Specific AI Solutions</h3>
            <p>
              Vertical SaaS solutions tailored to specific industries and use cases
            </p>

            <ul>
              <li>Healthcare: reports automation, RCM AI</li>
              <li>Manufacturing: predictive maintenance</li>
              <li>Logistics: route optimization & forecasting</li>
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CapabilitiesSection;